module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels_BW_Web-p-800-cc3f7aac21cc1d18abb36f04018f9c49.jpg";